'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
var $p;
/** @constructor */
function $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$() {
}
export { $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ as $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ };
$p = $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$;
/** @constructor */
function $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$() {
}
export { $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ as $h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ };
$h_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$.prototype = $p;
$p.eu = (function() {
  return "";
});
var $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$, "dev.cheleb.scalamigen.Defaultable$given_Defaultable_String$", ({
  iV: 1,
  aR: 1
}));
export { $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ as $d_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ };
var $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$;
function $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$() {
  if ((!$n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$)) {
    $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ = new $c_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$();
  }
  return $n_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$;
}
export { $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ as $m_Ldev_cheleb_scalamigen_Defaultable$given\uff3fDefaultable\uff3fString$ };
